import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { __RouterContext as RouterContext } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import AvatarNotesModal from './AvatarNotesModal'
import callAPI from '../../helpers/callAPI'
import moment from 'moment'

class Affiliate extends Component {
    static contextType = RouterContext
    state = {
        avatarNotesModalIsOpen: false,
        notesLoaded: false,
        notes: [],
        isNew: false,
    }

    fetchNotes = async () => {
        const { aid } = this.props
        this.setState({
            notesLoaded: false,
            notes: [],
        })
        if (aid) {
            const result = await callAPI(`affiliate/avatar/${aid}/log`, 'GET')
            if (result.success) {
                this.setState({
                    notes: result.log,
                    notesLoaded: true,
                })
            }
            else {
                this.setState({
                    notesLoaded: true,
                    notes: [],
                })
                this.props.showSystemMessage('error', result.errors.message)
            }
        } else {
            this.setState({
                notesLoaded: true,
                notes: [],
            })
            this.props.showSystemMessage('error', 'Affiliate ID is required to fetch notes.')
        }
    }

    componentDidMount() {
        if (this.context && this.context.location.pathname.startsWith('/avatar/')) {
            this.fetchNotes()
        }

        this.fetchIsNew()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.aid !== this.props.aid || prevProps.campaignId !== this.props.campaignId) {
            this.fetchIsNew()
        }
    }

    fetchIsNew = async () => {
        const { aid, campaignId } = this.props

        if (!aid || !campaignId) {
            if (this.state.isNew) {
                this.setState({ isNew: false })
            }
            return
        }

        const result = await callAPI(`campaign/${campaignId}/${aid}/isNew`, 'GET')

        this.setState({
            isNew: Boolean(result && result.isNew),
        })
    }


    render() {
        const currentPage = this.context ? this.context.location.pathname : ''
        /*  Props:
                aid = affiliate ID
                status = status
                name = name
                priority = priority
            Allowed override props:
                status: highlight
        */

        let classes = 'mb_element'

        if (this.props.priority <= 2 || this.props.priority === 'medium' || this.props.priority === 'high' || this.props.priority === 'Medium' || this.props.priority === 'High') {
            classes = `mb-element highlight`
        }

        if (this.props.status) {
            if (this.props.status.toUpperCase() === 'CANCELLED' || this.props.status.toUpperCase() === 'DORMANT' || this.props.status.toUpperCase() === 'C' || this.props.status.toUpperCase() === 'L' || this.props.status.toUpperCase() === 'R') {
                classes = `mb-element cancelled`
            }
        }

        if (this.props.offerStatus) {
            if (this.props.offerStatus.toUpperCase() !== 'A') {
                classes = `mb-element rejected`
            }
        }

        if (this.props.green) {
            classes = `mb-element active`
        }

        let url = this.props.aid ? `/affiliate/${this.props.aid}` : ''

        // let classes = this.props.status ? `mb-element ${this.props.status}` : "mb-element";
        // let url = this.props.aid ? `https://ott.maxbounty.com/afffollowup.cfm?a=${this.props.aid}` : '';     
        const notes = ['note1', 'note2', 'note3']; // Example notes array, replace with actual data if needed
        return (
            <>
                {currentPage.startsWith('/avatar/') && (
                    <>
                        <AvatarNotesModal affiliateId={this.props.aid} isOpen={this.state.avatarNotesModalIsOpen} setIsOpen={() => this.setState({...this.state, avatarNotesModalIsOpen: false })} refetch={() => this.fetchNotes()} />
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="bottom"
                            overlay={
                                <Popover id="popover-positioned-bottom" arrowprops={{ style: { display: 'none' } }} style={{ minWidth: '300px', maxWidth: '500px' }}>
                                    <Popover.Title className="d-flex justify-content-between" style={{ fontSize: '14px' }}>
                                        Recent Notes
                                    </Popover.Title>
                                    <Popover.Content className="p-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        {this.state.notes.length > 0 ? this.state.notes.map((item, index) => {
                                            //only show last 3
                                            if (index < this.state.notes.length - 3) {
                                                return null;
                                            }
                                            return (
                                                <div>

                                                    <div>
                                                        <span className="font-weight-bold">{moment(item.db_date).utc().format('YYYY-MM-DD HH:mm')}</span>
                                                        <span className="text-secondary ml-3">{item.full_name}</span>
                                                    </div>
                                                    <div>
                                                        <span style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: item.notes }} />
                                                        {item.image &&
                                                            <div className="mt-2" style={{ height: '100px' }}>
                                                                <a target="_blank" href={item.image}>
                                                                    <img src={item.image} className="border rounded" style={{ maxHeight: '100px' }} alt="Request image" crossOrigin={process.env.REACT_APP_PORTAL_URL} />
                                                                </a>
                                                            </div>
                                                        }
                                                        {item.file &&
                                                            <div className="mt-2">
                                                                <div className="alert alert-secondary d-inline-block m-0"><a target="_blank" href={item.file}>📄 Download File</a></div>
                                                            </div>
                                                        }
                                                    </div>
                                                    <hr />
                                                </div>
                                            )
                                        })

                                            : <div className="text-secondary">No notes.</div>
                                        }
                                    </Popover.Content>
                                </Popover>
                            }
                        >

                            <FontAwesomeIcon icon={faEye} onClick={() => this.setState({ avatarNotesModalIsOpen: true })} className='mr-1' style={{ cursor: 'pointer', color: '#007bff' }} />
                        </OverlayTrigger>
                    </>)}
                <Link className={classes} to={{ pathname: url }}>
                    <span className="name">
                        {this.props.name}{(this.props.affiliateStatus && this.props.affiliateStatus !== 'A') && <span title="Rejected">⛔</span>} {this.props.holdPayment && <span title="Hold Payment">🚩</span>} {this.state.isNew && <span title="New">🆕</span>}
                    </span>
                </Link>
            </>
        )
    }
}

export default Affiliate
